import { useMemo } from "react";

/**
 * Custom hook to extract the Polaris web components hash (sHash) from the DOM.
 * This hash is used to prefix CSS variables to avoid conflicts.
 *
 * @returns {string} The detected sHash or a default fallback.
 */
export const usePolarisHash = (): string => {
  return useMemo(() => {
    if (typeof document === "undefined") return "26021";

    try {
      const styleTags = document.querySelectorAll("style");
      for (const style of styleTags) {
        const match = style.innerHTML.match(/--s-global-color-([a-zA-Z0-9]+)/);
        if (match && match[1]) return match[1];
      }
    } catch (e) {
      console.warn("Failed to extract Polaris hash from DOM:", e);
    }

    return "26021"; // fallback to known polaris hash
  }, []);
};
